export default __webpack_public_path__ + "c580a7638e4e114b1de02cef11758a5f.jpg";